import React, { useState } from 'react';

export function SecretCell({ value, onCopy }) {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <td
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            onClick={onCopy}
            className="px-4 py-3 truncate max-w-xs cursor-pointer font-mono select-none hover:bg-slate-700/40 text-blue-400 transition-colors"
            title="Hover to reveal. Click to copy raw value."
        >
            {isHovered ? (value !== null ? String(value) : "NULL") : "••••••••"}
        </td>
    );
}
